import {
  QUERY_USER_PROFILE_INFO,
  QUERY_USER_PROJECT_PROFILE_INFO
} from "services/graphQL/queries";
import { getUser } from "services/auth";
import { useCIQQuery } from "./ciq-gql-hooks";

// This hook gets the user profile using subscription token
export const useUserProfileInfo = (emailId?: string) => {
  let email = emailId;
  const currentUser: any = getUser();
  if (!email) {
    email = currentUser?.email;
  }
  const { data, loading, error } = useCIQQuery(QUERY_USER_PROFILE_INFO, {
    variables: { where: { user: { email: { _eq: email } } } },
    skip: !email
  });

  return { loading, error, data };
};

// This hook gets the user project profile using project token
export const useUserProjectProfileInfo = (gqlClientForProject: any): any => {
  const currentUser: any = getUser();
  const { data, loading, error } = useCIQQuery(
    QUERY_USER_PROJECT_PROFILE_INFO,
    {
      variables: { where: { user: { email: { _eq: currentUser?.email } } } },
      skip: !gqlClientForProject || !currentUser?.email,
      client: gqlClientForProject
    }
  );
  return { loading, error, data };
};
